import { render } from "./LicensePageMeta.vue?vue&type=template&id=7d91d42f&ts=true"
import script from "./LicensePageMeta.vue?vue&type=script&lang=ts"
export * from "./LicensePageMeta.vue?vue&type=script&lang=ts"

import "./LicensePageMeta.vue?vue&type=style&index=0&id=7d91d42f&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__